import { CLOUD_FUNCTIONS } from "@common/src/constants/constants"
import { callCloudFunction } from "./cloud"

export const getDashboardToken = async (data) => {
    return callCloudFunction(CLOUD_FUNCTIONS.GET_DASHBOARD_AUTH, data)
}